import { Button } from '@/kit/Button';
import { Icon } from '@/kit/Icon';

interface TrialBalanceActionsProps {
  /** Leaves without storing the unsaved changes. */
  onCancel?: () => void;
  /** Stores the trial balance. */
  onSave?: () => void;
  /** A Save is in progress (both buttons wait for it). */
  isSaving?: boolean;
}

/**
 * BUG-036: as the old journal grid - nothing is stored until Save, and Cancel discards the changes. Ticket "Saving TB": the bar
 * stays at the bottom of the screen however long the grid is (sticky under the lines grid, see TrialBalanceBackdetails.scss).
 * APT354: Edit Details has no lines grid, so the same bar closes that tab.
 */
export function TrialBalanceActions({ onCancel, onSave, isSaving = false }: TrialBalanceActionsProps) {
  if (!onCancel && !onSave) {
    return null;
  }
  return (
    <div className="d-flex gap-15 hr-top pt-1 mt-1 tb-grid-actions">
      {onCancel && (
        <Button className="action-button secondary-button" type="button" disabled={isSaving} onClick={onCancel}>
          <Icon name="arrow_back" />
          <span>Cancel</span>
        </Button>
      )}
      {onSave && (
        <Button className="action-button primary-button" type="button" busy={isSaving} onClick={onSave}>
          <Icon name="save" outlined />
          <span>Save</span>
        </Button>
      )}
    </div>
  );
}
